function giveAnId(){
    return localStorage.length;
}

export default giveAnId;